import { render } from "./ManualView.vue?vue&type=template&id=050367db"
import script from "./ManualView.vue?vue&type=script&lang=js"
export * from "./ManualView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__